import { styled } from "styled-components";

export const Container = styled.div`
    width: 1280px;
    height: 546px;
    bottom: 0;
    padding: 50px 40px;
    box-sizing: border-box;
    border-top: 1px solid #e1e1e1;
`

export const MenuBox = styled.div`
    width: 160px;
`

export const MenuTitle = styled.span`
    font-size: 16px;
`